import { forwardRef, type SVGProps } from 'react';

export const ArticleOutlinedIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function ArticleOutlinedIcon(props, ref) {
  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 17C8.28334 17 8.521 16.904 8.713 16.712C8.905 16.52 9.00067 16.2827 9 16C9 15.7167 8.904 15.479 8.712 15.287C8.52 15.095 8.28267 14.9993 8 15C7.71667 15 7.479 15.096 7.287 15.288C7.095 15.48 6.99934 15.7173 7 16C7 16.2833 7.096 16.521 7.288 16.713C7.48 16.905 7.71734 17.0007 8 17ZM8 13C8.28334 13 8.521 12.904 8.713 12.712C8.905 12.52 9.00067 12.2827 9 12C9 11.7167 8.904 11.479 8.712 11.287C8.52 11.095 8.28267 10.9993 8 11C7.71667 11 7.479 11.096 7.287 11.288C7.095 11.48 6.99934 11.7173 7 12C7 12.2833 7.096 12.521 7.288 12.713C7.48 12.905 7.71734 13.0007 8 13ZM8 9C8.28334 9 8.521 8.904 8.713 8.712C8.905 8.52 9.00067 8.28267 9 8C9 7.71667 8.904 7.479 8.712 7.287C8.52 7.095 8.28267 6.99934 8 7C7.71667 7 7.479 7.096 7.287 7.288C7.095 7.48 6.99934 7.71734 7 8C7 8.28334 7.096 8.521 7.288 8.713C7.48 8.905 7.71734 9.00067 8 9ZM11 17H17V15H11V17ZM11 13H17V11H11V13ZM11 9H17V7H11V9ZM5 21C4.45 21 3.979 20.804 3.587 20.412C3.195 20.02 2.99934 19.5493 3 19V5C3 4.45 3.196 3.979 3.588 3.587C3.98 3.195 4.45067 2.99934 5 3H19C19.55 3 20.021 3.196 20.413 3.588C20.805 3.98 21.0007 4.45067 21 5V19C21 19.55 20.804 20.021 20.412 20.413C20.02 20.805 19.5493 21.0007 19 21H5ZM5 19H19V5H5V19Z"
        fill="currentColor"
      />
    </svg>
  );
});
